import script from "./HomeSplinePng.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeSplinePng.vue?vue&type=script&setup=true&lang=js"

import "./HomeSplinePng.vue?vue&type=style&index=0&id=3bb584a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb584a8"]])

export default __exports__